
import { useState } from 'react';
import { ArticleStatus } from '@/types/article-types';

export const useArticleFormState = (isEditMode: boolean) => {
  // Form state
  const [title, setTitle] = useState('');
  const [leadText, setLeadText] = useState('');
  const [content, setContent] = useState('');
  const [headerImageUrl, setHeaderImageUrl] = useState('');
  const [authorId, setAuthorId] = useState<string>('');
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [status, setStatus] = useState<ArticleStatus>('draft');
  const [publishDate, setPublishDate] = useState<Date | undefined>(undefined);
  
  // UI state
  const [loading, setLoading] = useState(isEditMode);
  const [saving, setSaving] = useState(false);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [error, setError] = useState<string | null>(null);
  const [calendarOpen, setCalendarOpen] = useState(false);

  return {
    // Form values
    title,
    setTitle,
    leadText,
    setLeadText,
    content,
    setContent,
    headerImageUrl,
    setHeaderImageUrl,
    authorId,
    setAuthorId,
    selectedTags,
    setSelectedTags,
    status,
    setStatus,
    publishDate,
    setPublishDate,
    
    // UI state
    loading,
    setLoading,
    saving,
    setSaving,
    formErrors,
    setFormErrors,
    error,
    setError,
    calendarOpen,
    setCalendarOpen
  };
};
